import React from 'react';
import './RecommendedQuestions.css';

const recommendedQuestions = [
  "Who is Allaah?",
  "What are the pillars of Islaam?",
  "What is Monotheism or Tawheed in Islam?",
  "Summarize the story of Prophet Moses or Musa",
  "Is Jesus or Isa son of God?"
];

function RecommendedQuestions({ onQuestionClick }) {
  return (
    <div className="recommended-questions">
      <h2 className="recommended-title">Quick questions to get you started</h2>
      <p className="recommended-subtitle">Click on any question to start your search</p>
      <div className="questions-grid">
        {recommendedQuestions.map((question, index) => (
          <button
            key={index}
            className="question-card"
            onClick={() => onQuestionClick(question)}
          >
            <img src="/icons/idea.svg" alt="Idea" className="question-icon" />
            <span className="question-text">{question}</span>
          </button>
        ))}
      </div>
    </div>
  );
}

export default RecommendedQuestions;
